"use client";

import { LinkButton } from "@/components/ui/LinkButton";
import { Reveal } from "@/components/motion";
import type { AboutClosingCtaContent } from "@/lib/api-types";

interface AboutClosingCTAProps {
  closingCta: AboutClosingCtaContent;
}

export function AboutClosingCTA({ closingCta }: AboutClosingCTAProps) {
  return (
    <section className="about-closing-cta site-section">
      <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
        <Reveal>
          <h2 className="font-display text-3xl font-bold text-white md:text-4xl">
            {closingCta.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/85">
            {closingCta.description}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <LinkButton href={closingCta.primary.href} variant="accent" size="lg">
              {closingCta.primary.label}
            </LinkButton>
            <LinkButton
              href={closingCta.secondary.href}
              variant="heroOutline"
              size="lg"
            >
              {closingCta.secondary.label}
            </LinkButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
